/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime: 2026-05-26 13:23:18
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 所有页面的路由配置
 * @FilePath: /icps_pcweb/src/router/index.js
 */
import { getPermission, ssoHX } from '@/api/api';
import { getButtonList } from "@/api/common.js";
import { SystemId } from '@/common/system.js';
import { getPerMission, getUserInfo, removeToken, setButtonList, setPerMission, setToken, setUserId, setUserInfo } from "@/utils/auth";
import { handleNavUrl, parseUrlParams } from '@/utils/urlAuthHandler';
import { delDomainCookie, getCookie, setDomainCookie } from '@/utils/utils.js';
import Watermark from "@/utils/watermark";
import Cookies from "js-cookie";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Vue from "vue";
import device from "vue-device-detector";
import VueRouter from "vue-router";
import { ICPS } from "./ICPS/index.js";
Vue.use(device);

Vue.use(VueRouter);
/* *初始路由
 * keepAlive为缓存组件，默认为全局缓存，设置为true为不缓存
 *
 */
export const routes = [
  {
    path: "/", //这个表示的是根目录，即一进入的页面
    redirect: "/lvshe/index", //设置页面一进来就显示的页面，即重定向到goods组件，这里写的内容是对应组将的component的值
  },
  {
    path: "/wps",
    name: "wps",
    component: () => import("@/views/wps.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/gpsDeviceOut",
    name: "gpsDeviceOut",
    component: () => import(
      '@/views/platform/ICPS/smart/schedul/gpsDevice.vue'),
  },
  {
    path: "/map",
    name: "map",
    component: () => import("@/views/map.vue"),
  },
  //进销存共享对接明细链接
  {
    path: "/purchaseSaleStoreDetail_HX",
    name: "purchaseSaleStoreDetail_HX",
    component: () => import(
      '@/views/platform/ICPS/Wise/docking/accountingSheet/purchaseSaleStoreDetail.vue'),
  },
  //配件材料对接明细链接
  {
    path: "/accessoryMaterialDetail_HX",
    name: "accessoryMaterialDetail_HX",
    component: () => import(
      '@/views/platform/ICPS/Wise/docking/accessorySheet/accessoryMaterialDetail.vue'),
  },
  //收入报账单对接明细链接
  {
    path: "/saleMonthReportDetail_HX",
    name: "saleMonthReportDetail_HX",
    component: () => import(
      '@/views/platform/ICPS/Wise/docking/incomeSheet/saleMonthReportDetail.vue'),
  },
  //原物料结算对接明细链接
  {
    path: "/materialSettleDetail_HX",
    name: "materialSettleDetail_HX",
    component: () => import(
      '@/views/platform/ICPS/Wise/docking/material/materialSettleDetail.vue'),
  },
  {
    path: "/productTransport_outside",
    name: "productTransport_outside",
    component: () => import("@/views/platform/ICPS/smart/schedul/productTransport_outside.vue"),
    meta: {
      title: "ICPS-1",
      keepAlive: true,
    },
  },
  {
    path: "/login",
    name: "login",
    // redirect: '/login',
    component: () => import("@/views/smsLogin.vue"),
  },
  {
    path: "/indexEditor",
    name: "indexEditor",
    component: () => import("@/views/home/indexEditor/indexEditor.vue"),
    meta: {
      title: "首页编辑",
      keepAlive: true,
    },
  },
  {
    path: "/indexSee",
    name: "indexSee",
    component: () => import("@/views/home/indexSee/indexSee.vue"),
    meta: {
      title: "首页预览",
      keepAlive: true,
    },
  },
  {
    path: "/lvshe",
    component: () => import("@/views/pages/pages.vue"),
    children: [
      {
        path: "index",
        name: "index",
        component: () => import(/* webpackChunkName: 'home'*/ "@/views/home/index/index.vue"),
        meta: {
          title: "首页",
          keepAlive: true,
        },
      },
      {
        path: "details",
        name: "details",
        component: () => import(/* webpackChunkName: 'home'*/ "@/views/pages/details.vue"),
        meta: {
          title: "通知详情",
        },
      },
      {
        path: "Saleskanban",
        name: "Saleskanban",
        component: () => import(/* webpackChunkName: 'home' */ "@/views/pages/Saleskanban/Saleskanban.vue"),
        meta: {
          title: "销售看板",
          keepAlive: true,
        },
      },
      {
        path: "userInfo",
        name: "userInfo",
        component: () => import(/* webpackChunkName: 'home'*/ "@/views/pages/userInfo/userInfo.vue"),
        meta: {
          title: "个人中心",
          keepAlive: true,
        },
      },
      {
        path: "download",
        name: "download",
        component: () => import(/* webpackChunkName: 'home'*/ "@/views/pages/download/download.vue"),
        meta: {
          title: "下载专区",
          keepAlive: true,
        },
      },
      {
        path: "controlLibrary",
        name: "controlLibrary",
        component: () => import(/* webpackChunkName: 'home'*/ "@/views/platform/platform_item/Signed/processConfig/controlLibrary.vue"),
        meta: {
          title: "控件库配置",
        },
      },
      {
        path: "base",
        component: () => import("@/views/platform/platform.vue"),
        children: [
          {
            path: "basicIndex",
            name: "basicIndex",
            component: () => import(/* webpackChunkName: 'huanyin'*/ "@/views/platform/platform_item/index.vue"),
            meta: {
              title: "欢迎使用基础系统",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "organization",
            name: "organization",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/organization/organization.vue"),
            meta: {
              title: "组织管理",
              system: "organization",
              // keepAlive: true
            },
          },
          {
            path: "jobs",
            name: "jobs",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/jobs/jobs.vue"),
            meta: {
              title: "岗位管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "user",
            name: "user",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/user/user.vue"),
            meta: {
              title: "用户管理",
              system: "organization",
              // keepAlive: true,
            },
          },
          {
            path: "business",
            name: "business",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/business/business.vue"),
            meta: {
              title: "业务系统管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "function",
            name: "function",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/function/function.vue"),
            meta: {
              title: "功能管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "IndividualUser",
            name: "IndividualUser",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/IndividualUser/IndividualUser.vue"),
            meta: {
              title: "个人用户创建",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "PersonalRights",
            name: "PersonalRights",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/PersonalRights/PersonalRights.vue"),
            meta: {
              title: "个人权限授权",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "permissions",
            name: "permissions",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/permissions/permissions.vue"),
            meta: {
              title: "权限管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "PermissionsApply",
            name: "PermissionsApply",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/PermissionsApply/PermissionsApply.vue"),
            meta: {
              title: "权限申请",
              system: "organization",
            },
          },
          {
            path: "partTime",
            name: "partTime",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/partTime/partTime.vue"),
            meta: {
              title: "兼职管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "role",
            name: "role",
            component: () => import("@/views/platform/platform_item/basicData/role/role.vue"),
            meta: {
              /* webpackChunkName: 'basicData1'*/ title: "角色管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "DataAccess",
            name: "DataAccess",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/DataAccess/DataAccess.vue"),
            meta: {
              title: "数据权限配置",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "versionMan",
            name: "versionMan",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/versionMan/versionMan.vue"),
            meta: {
              title: "版本管理",
              system: "organization",
            },
          },
          {
            path: "dictionary",
            name: "dictionary",
            component: () => import(/* webpackChunkName: 'basicData1'*/ "@/views/platform/platform_item/basicData/dictionary/dictionary.vue"),
            meta: {
              title: "字典管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "notice",
            name: "notice",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/notice/notice.vue"),
            meta: {
              title: "通知通告",
              system: "organization",
              // keepAlive: true,
            },
          },
          {
            path: "noticeEdit",
            name: "noticeEdit",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/notice/noticeEdit.vue"),
            meta: {
              title: "编辑通知通告",
              system: "organization",
            },
          },
          {
            path: "pageConfig",
            name: "pageConfig",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/pageConfig/pageConfig.vue"),
            meta: {
              title: "首页配置",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "scheduling",
            name: "scheduling",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/scheduling/scheduling.vue"),
            meta: {
              title: "调度维护",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "APPmanagement",
            name: "APPmanagement",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/APPmanagement/APPmanagement.vue"),
            meta: {
              title: "APP管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "mobileBanner",
            name: "mobileBanner",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/mobileBanner/mobileBanner.vue"),
            meta: {
              title: "移动端banner",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "aboutUs",
            name: "aboutUs",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/aboutUs/aboutUs.vue"),
            meta: {
              title: "关于华西",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "attachment",
            name: "attachment",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/attachment/attachment"),
            meta: {
              title: "附件管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "CodingRules",
            name: "CodingRules",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/CodingRules/CodingRules"),
            meta: {
              title: "单据编码规则",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "SystemParameters",
            name: "SystemParameters",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/SystemParameters/SystemParameters"),
            meta: {
              title: "系统参数",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "KeytoLog",
            name: "KeytoLog",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/KeytoLog/KeytoLog"),
            meta: {
              title: "关键日志记录",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "DailyLog",
            name: "DailyLog",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/DailyLog/DailyLog"),
            meta: {
              title: "日常日志记录",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "InterfaceTime",
            name: "InterfaceTime",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/InterfaceTime/InterfaceTime"),
            meta: {
              title: "接口访问时长",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "MessageLog",
            name: "MessageLog",
            component: () => import(/* webpackChunkName: 'basicData2'*/ "@/views/platform/platform_item/basicData/MessageLog/MessageLog"),
            meta: {
              title: "消息日志",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "DieEemente",
            name: "DieEemente",
            component: () => import(/* webpackChunkName: 'Signed'*/ "@/views/platform/platform_item/Signed/DieEemente/DieEemente.vue"),
            meta: {
              title: "审批要素",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "TypeApprover",
            name: "TypeApprover",
            component: () => import(/* webpackChunkName: 'Signed'*/ "@/views/platform/platform_item/Signed/TypeApprover/TypeApprover.vue"),
            meta: {
              title: "审批人类型",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "processAgent",
            name: "processAgent",
            component: () => import(/* webpackChunkName: 'Signed'*/ "@/views/platform/platform_item/Signed/processAgent/processAgent.vue"),
            meta: {
              title: "流程代理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "ProcessManagement",
            name: "ProcessManagement",
            component: () => import(/* webpackChunkName: 'Signed'*/ "@/views/platform/platform_item/Signed/ProcessManagement/ProcessManagement.vue"),
            meta: {
              title: "流程管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "ProcessTaskMaintenance",
            name: "ProcessTaskMaintenance",
            component: () => import(/* webpackChunkName: 'Signed'*/ "@/views/platform/platform_item/Signed/ProcessTaskMaintenance/ProcessTaskMaintenance.vue"),
            meta: {
              title: "流程任务维护",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "processConfig",
            name: "processConfig",
            component: () => import(/* webpackChunkName: 'Signed'*/ "@/views/platform/platform_item/Signed/processConfig/processConfig.vue"),
            meta: {
              title: "流程配置",
              system: "organization",
            },
            hidden: true,
          },
          {
            path: "NewTask",
            name: "NewTask",
            component: () => import(/* webpackChunkName: 'Signed'*/ "@/views/platform/platform_item/task/NewTask/NewTask.vue"),
            meta: {
              title: "新建任务",
              system: "organization",
              // keepAlive: true,
            },
          },
          {
            path: "taskCenter",
            name: "taskCenter",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/taskCenter/taskCenter.vue"),
            meta: {
              title: "新建任务",
              system: "organization",
              // keepAlive: true,
            },
          },
          {
            path: "taskDetails",
            name: "taskDetails",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/taskCenter/taskDetails.vue"),
            meta: {
              title: "任务处理",
              system: "organization",
              // keepAlive: true
            },
          },
          {
            path: "taskagents",
            name: "taskagents",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/taskagents/taskagents"),
            meta: {
              title: "待办任务",
              system: "organization",
            },
          },
          {
            path: "undertakesTask",
            name: "undertakesTask",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/undertakesTask/undertakesTask"),
            meta: {
              title: "待发任务",
              system: "organization",
            },
          },
          {
            path: "iama",
            name: "iama",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/iama/iama"),
            meta: {
              title: "本人发起",
              system: "organization",
            },
          },
          {
            path: "submiTask",
            name: "submiTask",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/submiTask/submiTask"),
            meta: {
              title: "提交任务",
              system: "organization",
            },
          },
          {
            path: "doTasks",
            name: "doTasks",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/doTasks/doTasks"),
            meta: {
              title: "已办任务",
              system: "organization",
            },
          },
          {
            path: "colTask",
            name: "colTask",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/colTask/colTask"),
            meta: {
              title: "收藏任务",
              system: "organization",
            },
          },
          {
            path: "Trackitems",
            name: "Trackitems",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/Trackitems/Trackitems"),
            meta: {
              title: "跟踪事项",
              system: "organization",
            },
          },
          {
            path: "recycleTask",
            name: "recycleTask",
            component: () => import(/* webpackChunkName: 'task'*/ "@/views/platform/platform_item/task/recycleTask/recycleTask"),
            meta: {
              title: "流程回收站",
              system: "organization",
            },
          },
          {
            path: "ThirdpartyApp",
            name: "ThirdpartyApp",
            component: () => import(/* webpackChunkName: 'interface'*/ "@/views/platform/platform_item/interface/ThirdpartyApp"),
            meta: {
              title: "第三方应用维护",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "APIReg",
            name: "APIReg",
            component: () => import(/* webpackChunkName: 'interface'*/ "@/views/platform/platform_item/interface/APIReg"),
            meta: {
              title: "对外API注册",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "syncDatasource",
            name: "syncDatasource",
            component: () => import(/* webpackChunkName: 'sync'*/ "@/views/platform/platform_item/sync/syncDatasource"),
            meta: {
              title: "数据源管理",
              system: "organization",
              keepAlive: true,
            },
          },
          {
            path: "syncTask",
            name: "syncTask",
            component: () => import(/* webpackChunkName: 'sync'*/ "@/views/platform/platform_item/sync/syncTask"),
            meta: {
              title: "同步任务管理",
              system: "organization",
              keepAlive: true,
            },
          },
        ],
      },
    ],
  },
];
/* 动态路由*/
export const errroutes = [
  {
    path: "/404",
    component: () => import("@/views/error/error404"),
  },
  {
    path: "/401",
    component: () => import("@/views/error/error401"),
  },
  {
    path: "*",
    redirect: "/401",
  },
];
export const addroutes = [...ICPS, ...errroutes];
const router = new VueRouter({
  routes,
});
/* 动态添加路由*/
router.addRoutes(addroutes);
/*进度条配置*/
NProgress.configure({
  easing: "linear",
  speed: 500, // 动画时间
  showSpinner: false, // 不显示转动的小圆圈
});
export default router;

const whiteList = [
  "checkflows",
  "board_Salesofkanban",
  "checkflows2",
  "EngineeringEvaluation",
  "QIUBO_SCM_TEST",
  "QIUBO_SCM_TEST2",
  "login",
  "index",
  "download",
  "userInfo",
  "Saleskanban",
  "details",
  "ProjectClarifiFlow",
  "surplusFlow",
  "ChangeLevelCoop",
  "SupplierRating",
  "SiteProportion",
  "CarTransfer",
  "PurchaseOrder",
  "ShareMaintenance",
  "AddOrder",
  "RiskControlFlow",
  "ThirdCheck1",
  "ThirdCheck2",
  "SpringbackCheck",
  "ExceptionsApply1",
  "ExceptionsApply2",
  "ExceptionsApply3",
  "taskDetails",
  "SpecialCheckFlows",
  "sign_mix",
  "sign_CPYquality",
  "sign_Sitequality",
  "sign_Wise_contactsbusiness1",
  "sign_Wise_contactsbusiness2",
  "sign_material",
  "sign_concrete",
  "sign_Wise_rentunit1",
  "sign_Wise_rentunit2",
  "sign_Wise_rentunit3",
  "sign_Wise_rentunit4",
  "sign_smartschedulj",
  "sign_stocksake1",
  "sign_stocksake2",
  "sign_smartscheduld",
  "sign_ADRN",
  "basicIndex",
  "ICPSIndex",
  "wps",
  "processConfig",
  "sign_smartdata",
  "smartdataPlan",
  "materialScrap",
  "indexEditor",
  "indexSee",
  "outUrl",
  "map",
  "productTransport_outside",
  "insideUrl",
  "cancleOrder",
  "dockPlan",
  "priceMaintenance_sign",
  "sign_settlementTask",
  "sign_settlementTaskBack",
  "adjustQuantity_sign",
  "sign_infrastructure",
  "sign_internalunit",
  "accountingSheetDetail",
  "purchaseSaleStoreDetail",
  "purchaseSaleStoreDetail_HX",
  "incomeSheetDetail",
  "saleMonthReportDetail",
  "saleMonthReportDetail_HX",
  "accessoryMaterialDetail",
  "accessoryMaterialDetail_HX",
  "materialSettleDetail_HX",
  "accessoryAccountingSheetDetail",
  "gpsDeviceOut",
  "overdueSupplyReviewApproval",
  "debtSupplyDetailApproval",
  "processDifferControlApproval",
  "superGraphCalculationApproval",
  "PreCommissioningApproval",
  "ExceedContractApproval",
];
/**
 * 进入路由前
 */
router.afterEach(async () => {
  const hasWaterMask = window.sessionStorage.getItem("watermark") === "Y";
    const UserInfo = await getUserInfo();
  if (UserInfo && hasWaterMask) {
    Watermark.set(UserInfo.userRealName);
  }
  
  NProgress.done();
});
router.beforeEach(async(to, from, next) => {
  console.log(to, from);
  console.log(Vue.prototype.$device.mobile);
  NProgress.start();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  const paramsObj = {};
  /**智慧办公导航跳转过滤*/
  console.log("🚀 ~ window.location.search:", window.location.search)
  if (window.location.search) {
    if (window.location.search.indexOf('nav') > -1) {
      const handled = await handleNavUrl();
      if (handled) {
        next();
      } else {
        // 清理 URL 中的 path=nav 参数
        const url = new URL(window.location.href);
        if (url.searchParams.has('path')) {
            url.searchParams.delete('path');
            // 如果没有其他参数，确保 search 为空
            const newUrl = url.pathname + (url.search ? url.search : '') + url.hash;
            window.history.replaceState({}, document.title, newUrl);
        }
        next({ path: '/login' });
      }
    } else {
      parseUrlParams(window.location.search, paramsObj);
    }
  } else if (window.location.hash) {
    const [url, params] = window.location.hash.split('?');
    console.log("🚀 ~ url:", url)
    console.log("🚀 ~ params:", params)
    console.log("🚀 ~ paramsObj:", paramsObj)
    parseUrlParams(params || '', paramsObj);
  }
  /**善建云通登录*/
  paramsObj.systemId = SystemId
  paramsObj.type = 1
  paramsObj.appCode = ''
  paramsObj.appletApp = ''

  // alert(JSON.stringify(paramsObj))

  console.log(paramsObj);
  console.log(from.path, to.query);
  console.log(to.name, to.query);
  console.log(paramsObj.appid , paramsObj.ticket);
  if (paramsObj.appid && paramsObj.ticket && from.path === '/') {
    try {
      // alert(JSON.stringify(paramsObj))
      let userData = await ssoHX(paramsObj);
      if (userData && userData.code === 1001) {
        removeToken();
        setToken(userData.data.accessToken);
        Cookies.remove('ICPS_accessToken', { path: '' })
        delDomainCookie('ICPS_accessToken');
        setDomainCookie('ICPS_accessToken', userData.data.accessToken, 1000 * 60 * 60)
        setToken(userData.data.accessToken);
        setUserId(userData.data.userId);
        if (userData.adminStatus == 1) {
          userData.data.userCompanyId = userData.companyId
          userData.data.companyId = null
        }
        setUserInfo(userData.data);
        router.app.$options.store.dispatch("user/setToken", accessTokenFromCookie)
        const permissionData = await getPermission();
        if (permissionData && permissionData.code === 1001) {
          setPerMission(permissionData.data)
        }
      }
      next();
    } catch (error) {
      next({ path: '/login' })
      return
    }
  }
  if(to.query.token){
    setToken(to.query.token);
  }
  /**共享对接*/
  if (to.path == "purchaseSaleStoreDetail_HX") {
    next();
    return;
  }
  if (to.path == "saleMonthReportDetail_HX") {
    next();
    return;
  }
  if (to.path == "accessoryMaterialDetail_HX") {
    next();
    return;
  }
  if (to.path == "materialSettleDetail_HX") {
    next();
    return;
  }
  /*h5跳转pc */
  if (to.name == "overdueSupplyReviewApproval") {
    next();
    return;
  }
  //判断为生产运输的话给title加上站点名
  let stationUserInfo = JSON.parse(window.sessionStorage.getItem("stationUserInfo"));
  let stationInfo = stationUserInfo?.stationInfo;
  if(to.name == 'productTransport_outside') {
    document.title = stationInfo ? ('ICPS-' + stationInfo.name) : 'ICPS'
  }
  const accessTokenFromCookie = getCookie("ICPS_accessToken") || null;
  console.log("🚀 ~ accessTokenFromCookie:", accessTokenFromCookie)
  // getCookie('accessToken')
  // const accessTokenFromCookie = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTAzNDgxOTEsInVzZXJJZCI6IueuoeeQhuWRmDgyIyMjMSJ9.-K6Xm_i7Hh5jQCW9IladwYoEfUTTNiA-c76XNjKVRlA'
  /**对于有权限的页面进行按钮权限获取*/
  let token = window.localStorage.getItem("access-token") || null;
  console.log("🚀 ~ token:", token)
  if (accessTokenFromCookie !== token && !!accessTokenFromCookie && from?.name !== "login" && to.name !=="purchaseSaleStoreDetail_HX" && to.name !=="saleMonthReportDetail_HX" && to.name !=="accessoryMaterialDetail_HX" && to.name !=="materialSettleDetail_HX") {
    router.app.$options.store.dispatch("user/setToken", accessTokenFromCookie);
    token = accessTokenFromCookie;
  }
  // 拦截工程交底 判断为移动端打开H5页面
  // if (to.name === "ProjectClarifiFlow") {
  //   console.log(Vue.prototype.$device.mobile);
  //   var params = to.query;

  //   // 将参数转换为查询字符串
  //   var queryString = Object.keys(params)
  //     .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(params[key]))
  //     .join("&");
  //   // 打开新窗口的URL
  //   var url = "http://10.31.0.111:8089/#/ProjectClarifiFlowH5?";
  //   // 打开窗口
  //   if (Vue.prototype.$device.mobile) {
  //     // let pathHerf = router.resolve({
  //     //   path: "http://10.31.0.111:8089/#/ProjectClarifiFlowH5/", // 你自己要跳转的路径
  //     //   query: to.query, //其中list是一个数组或者对象
  //     // });
  //     // console.log(pathHerf)
  //     // window.open(pathHerf.href, "_blank");
  //     // 参数对象

  //     console.log(url + queryString + "");
  //     window.open(url + queryString + `&token=${token}`, "_self");
  //     // window.open(url + queryString, "_blank");
  //     NProgress.done();
  //     return;
  //   } else {
  //     console.log("其他");
  //   }
  // }
  const LOGIN_PATH = "/login";
  if (token && to.path !== LOGIN_PATH && to.path!=='/purchaseSaleStoreDetail_HX' && to.path!=='/saleMonthReportDetail_HX' && to.path!=='/accessoryMaterialDetail_HX' && to.path!=='/materialSettleDetail_HX' && to.path!=='/overdueSupplyReviewApproval') {
    getButtonList({ functionCode: to.name })
      .then(res => {
        if (res.code !== 1001) {
          return next({ path: "/404" });
        }
        setButtonList(res.data);
        next();
      })
      .catch(() => {
        next({ path: "/404" });
      });
  } else {
    if (!token && to.path !== LOGIN_PATH && to.path!=='/purchaseSaleStoreDetail_HX' && to.path!=='/saleMonthReportDetail_HX' && to.path!=='/accessoryMaterialDetail_HX' && to.path!=='/materialSettleDetail_HX') {
      next({ path: LOGIN_PATH });
    } else {
      next();
    }
  }

  /**
   * @Description: 设置白名单
   * @Param:
   * @Author: wangwangwang
   */
  if (whiteList.indexOf(to.name) !== -1) {
    if (to.name == "board_Salesofkanban") {
      getButtonList({ functionCode: to.query.name || "board_Salesofkanban" }).then(res => {
        if (res.code == 1001) {
          next();
          setButtonList(res.data);
        } else {
          next({ path: "/404" });
        }
      });
      return;
    }
    next();
    return;
  }
  /**404,401不需要权限*/
  if (to.path == "/401" || to.path == "/404") {
    next();
    return;
  }
  /**对需要权限的页面进行权限验证，无权限条状401报错页面*/
  if (getPerMission()?.functionLimitList.findIndex(res => res.code == to.name) == -1) {
    next({ path: "/401" });
    return;
  }
     // 拦截运输地图，跳单独的页面
     if (to.name === "smartschedulk") {
      let routeUrl = router.resolve({
        path: "/map",
      });
      window.open(routeUrl.href, "_blank");
      NProgress.done();
      return;
    }
});
